<template>
  <div class="com-container">
    <a-carousel autoplay>
      <div v-for="(item, index) in banners" :key="index" class="carousel-content">
        <img class="carousel-image" :src="item.url" :alt="item.alt">
        <div v-if="item.content" class="carousel-title">
          <p class="title">{{ item.content.title }}</p>
          <p class="title">{{ item.content.label }}</p>
          <span class="label">{{ item.content.other }}</span>
        </div>
      </div>
    </a-carousel>
  </div>
</template>

<script>

export default {
  name: 'HomeView',

  data() {
    return {
      banners: [
        { url: require('../../assets/image/banner1.png'), alt: '****' },
        { url: require('../../assets/image/banner2.png'), alt: '****' },
        { url: require('../../assets/image/banner3.png'), alt: '****' }
      ],
      isVisble: false
    }
  },
  methods: {
    handleVisble() {
      this.isVisble = !this.isVisble
    }
  }
}
</script>

<style lang="scss" scoped>
.com-container {
  height: 800px;
  position: relative;

  .carousel-content {
    width: 100%;
    height: 800px;
    position: relative;

    .carousel-image {
      width: 100%;
      height: 100%;
    }

    .carousel-title {
      width: 700px;
      position: absolute;
      top: 282px;
      left: 252px;
      font-family: PingFangSC, PingFangSC-Semibold;
      text-align: left;
      color: #ffffff;

      .title {
        white-space: pre-wrap;
        font-size: 96px;
        line-height: 120px;
        font-weight: 600;
        letter-spacing: 0.51px;
      }

      .label {
        font-size: 48px;
        font-family: MicrosoftYaHei, MicrosoftYaHei-Regular;
        font-weight: 400;
        color: #e2dfd5;
        line-height: 72px;
        letter-spacing: 0.64px;
      }
    }
  }

  .carousel-statics {
    position: absolute;
    top: 93px;
    right: 180px;
    text-align: left;
    width: 392px;
    height: 610px;
    padding: 40px 51px 32px 51px;
    background: rgba(255, 255, 255, 0.85);
    border-radius: 20px;
    box-shadow: 0px 0px 37px 0px rgba(192, 192, 192, 0.62);
    backdrop-filter: blur(14.67px);

    .carousel-statics-label {
      font-size: 21px;
      color: #2d2d2d;
      font-weight: 600;
      font-family: PingFangSC, PingFangSC-Semibold;
      margin-bottom: 36px;

      img {
        width: 62px;
        height: 8px;
      }
    }

    .carousel-statics-show {
      display: flex;
      margin-bottom: 30px;

      img {
        width: 72px;
        height: 88px;
        margin-left: 9px;
        margin-right: 20px;
      }

      .carousel-statics-show-detail {
        .detail-value {
          .unit {
            color: #0C27AF;
            font-weight: 700;
            font-size: 20px;
          }
        }

        .detail-label {
          font-size: 16px;
          white-space: nowrap;
        }
      }
    }
  }
}
</style>

<style lang="scss">
.carousel-statics-show-detail .detail-value .ant-statistic-content {
  font-size: 40px;
  color: #0C27AF;
  font-weight: 700;
  line-height: 50px;
}

.ant-carousel .slick-dots-bottom {
  width: auto;
  left: 252px;
  bottom: 70px;
}

.ant-carousel .slick-dots li {
  width: 40px;
  height: 4px;
  margin: 0 7px;
  border-radius: 3px;
}

.ant-carousel .slick-dots li button {
  width: 40px;
}

@media (max-width: 1024px) {
  .carousel-title {
    width: 100%;
    left: 0;
    top: auto;
    padding: 20px 16px;
  }
}

@media (max-width: 768px) {
  .com-container {
    height: auto;
    padding-bottom: 24px;
  }

  .carousel-content {
    height: auto;
  }

  .carousel-title {
    position: static;
    width: 100%;
    padding: 22px 16px;
    top: auto;
    left: auto;
    font-size: 16px;
  }

  .carousel-title .title {
    font-size: 32px;
    line-height: 40px;
  }

  .carousel-title .label {
    font-size: 20px;
    line-height: 28px;
  }

  .carousel-statics {
    position: static;
    width: 100%;
    right: auto;
    top: auto;
    height: auto;
    margin: 16px auto 0;
    padding: 24px 16px;
    box-shadow: none;
    background: rgba(255, 255, 255, 0.95);
    border-radius: 20px;
    backdrop-filter: none;
  }

  .carousel-statics-show {
    flex-direction: column;
    align-items: flex-start;
  }

  .carousel-statics-show img {
    margin: 0 0 12px 0;
  }

  .carousel-statics-label {
    font-size: 18px;
    margin-bottom: 18px;
  }

  .carousel-statics-show-detail .detail-value .ant-statistic-content {
    font-size: 28px;
    line-height: 36px;
  }

  .ant-carousel .slick-dots-bottom {
    left: 50% !important;
    transform: translateX(-50%) !important;
    bottom: 20px !important;
  }
}
</style>
